<!-- FIREBASE V9 -->
<template>
<v-container fluid>
    <v-card class="ma-2" outlined>
        <v-card-title v-if="this.id">
            <v-btn icon @click="$router.go(-1)">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            {{ title }}
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class="ml-5 mt-3" @click="goToProgramViewCoach">
                add coach
            </v-btn>
            <v-btn color="primary" dark class="ml-5 mt-3" @click="goToProgramView">
                view
            </v-btn>
        </v-card-title>
        <v-card-title v-else>
            <v-btn icon @click="$router.go(-1)">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            {{ title }}
        </v-card-title>
        <v-progress-linear indeterminate color="blue darken-2" v-if="loading"></v-progress-linear>

        <!-- Dialog for confirm update user -->
        <v-dialog v-model="dialog" max-width="400px">
            <v-card>
                <v-card-title class="text">Done!</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="goToItemList">OK</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-form ref="form" lazy-validation v-model="valid" class="ma-5 pa-5">
            <v-layout wrap="true">
                <v-flex xs12>
                    <p class="text-subtitle-1 bg2-text mr-md-3">ชื่อแผนปรับเปลี่ยนพฤติกรรม</p>
                </v-flex>
                <v-flex xs12 md5>
                    <v-text-field outlined :rules="requiredRule" v-model="editedItem.name" class="d-flex xs12 md7">
                    </v-text-field>
                </v-flex>
                <v-flex xs12 md3 class="pa-2">
                    <!-- <v-btn d-flex color="blue darken-1" text @click="goToItemList"> Cancel </v-btn> -->
                    <v-btn v-if="this.id" color="blue darken-1" text @click="submit">
                        Save
                    </v-btn>
                    <v-btn v-else color="blue darken-1" text @click="submit">
                        Add
                    </v-btn>
                </v-flex>
            </v-layout>

            <v-layout wrap="true" v-if="this.id">
                <v-flex xs12>
                    <coach-list-component :programId="id" />
                </v-flex>
            </v-layout>
        </v-form>
    </v-card>
</v-container>
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import {
    mapGetters
} from "vuex";
import getProgramInfoByIdForEdit from "../data/getProgramInfoByIdForEdit";
import setProgramInfo from '../data/setProgramInfo';
import formatData from "../utils/formatData";
import getUserCoachList from "../data/getUserCoachList";
import getUserInfoByUserId from "../data/getUserInfoByUserId";
import coachListComponent from "../components/ProgramCoachListComponent.vue";
export default {
    name: 'ProgramManagementForm',
    metaInfo: {
        title: 'Program Management Form'
    },
    components: {
        coachListComponent
    },
    data() {
        return {
            editedItem: {
                name: ""
            },
            defaultItem: {
                name: ""
            },
            //to validate from
            valid: false,
            requiredRule: [
                (value) => !!value || "Required."
            ],
            refRule: [
                (value) => !!value || "Required.",
            ],
            dialog: false,
            title: "Add new Program",
            loading: false,
            coachList: []
        };
    },

    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin | Coach Program";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });
        this.id = this.$route.params.id;
    },
    computed: {
        ...mapGetters([
            "loggedInUserId",
            "isAuthenticated",
            "isSuperAdmin",
            "isChallengeAdmin",
            "isAccessCoachAdmin"
        ]),
    },
    methods: {
        initialize() {
            if (this.isAccessCoachAdmin) {
                (async () => {
                    this.loading = true;

                    //get coach list from org of owner
                    let ownerId = this.loggedInUserId;
                    if (this.id) {
                        this.editedItem = await getProgramInfoByIdForEdit(this.id);
                        ownerId = this.editedItem.owner;
                    }
                    const userInfo = await getUserInfoByUserId(ownerId);
                    const coachAdminList = await getUserCoachList(userInfo.orgId);
                    let coachHash = [];
                    if (coachAdminList.length) {
                        coachAdminList.forEach((v) => {
                            if (ownerId != v.uid) { // to remove owner id from coach list
                                coachHash[v.uid] = v.name;
                                this.coachList.push({
                                    'value': v.uid,
                                    'text': v.name
                                });
                            }
                        });
                    }

                    if (this.id) {
                        this.title = 'Edit Program';

                        const editCoachList = [];
                        if (this.editedItem.coachList != undefined && this.editedItem.coachList.length) {
                            this.editedItem.coachList.forEach((v) => {
                                if (coachHash[v] != undefined) {
                                    editCoachList.push({
                                        'value': v,
                                        'text': coachHash[v]
                                    });
                                }
                            });
                        }
                        this.editedItem.coachList = editCoachList;
                    }
                    this.loading = false;
                })();
            } else {
                this.$router.push(`/dashboard`);
            }
        },
        _formatData(type, value) {
            return formatData(type, value);
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        submit() {
            (async () => {
                //to validate from before submit
                await this.$refs.form.validate();

                if (this.valid) {
                    // const coachListSelected = [];
                    // if (this.editedItem.coachList.length) {
                    //     this.editedItem.coachList.forEach((item) => {
                    //         coachListSelected.push(item.value);
                    //     });
                    // }

                    (async () => {
                        if (this.id) {
                            // this.editedItem.coachList = coachListSelected;
                            this.editedItem.updatedDate = new Date();
                            this.editedItem.updatedBy = this.loggedInUserId;
                            await setProgramInfo(this.editedItem, this.id);
                        } else {
                            this.editedItem.createdDate = new Date();
                            this.editedItem.createdBy = this.loggedInUserId;
                            this.editedItem.owner = this.loggedInUserId;
                            // this.editedItem.coachList = coachListSelected;
                            this.editedItem.updatedDate = new Date();
                            this.editedItem.updatedBy = this.loggedInUserId;
                            await setProgramInfo(this.editedItem);
                        }

                        setTimeout(() => {
                            this.dialog = true;
                        }, "3000");
                    })();
                }
            })();
        },
        close() {
            this.dialog = false;
        },
        goToItemList() {
            this.$router.push(`/program/program-list`);
        },
        goToProgramView() {
            this.$router.push(`/program/program-list/view/${this.id}`);
        },
        goToProgramViewCoach() {
            this.$router.push(`/program/program-list/edit/${this.id}/addCoach`);
        }
    },
};
</script>

<style>
.v-textarea textarea {
    height: 70px;
}

p {
    margin-bottom: 0 !important;
}

p.bg2-text {
    line-height: 47px !important;
    text-align: right;
}

p.bg-text {
    line-height: 55px !important;
    text-align: right;
}
</style>
